export interface MetaTagConfig {
    title: string;
    description: string;
    keywords: string;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    canonicalUrl?: string;
}

export interface PageMetaTags {
    English: MetaTagConfig;
    Hindi: MetaTagConfig;
}

const DEFAULT_OG_IMAGE = "/bhrigoo_rishi.png";

// SEO Meta Tags for all public pages
export const SEO_META_TAGS: Record<string, PageMetaTags> = {
    // Landing Page
    landing: {
        English: {
            title: "BhriguGPT - AI Astrologer | Kundli, Tarot, Numerology & More",
            description: "Chat with BhriguGPT, your AI astrologer. Free Kundli, Tarot, Numerology, Horoscope, Panchang, Palm Reading & 15+ spiritual services in Hindi and English.",
            keywords: "AI astrologer, vedic astrology, kundli, tarot reading, numerology, palm reading, horoscope, panchang, birth chart, face reading, dream interpretation, kundli matching, KP astrology, lal kitab, chinese astrology, western astrology, past life reading, jyotish, free kundli online, astrology chat AI",
            ogTitle: "BhriguGPT - Your Personal AI Astrologer | 15+ Spiritual Services",
            ogDescription: "From Vedic Kundli to Tarot, Numerology, Palm Reading, Western & Chinese Astrology — BhriguGPT is your AI-powered guide to life's biggest questions.",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/"
        },
        Hindi: {
            title: "BhriguGPT - AI ज्योतिषी | कुंडली, टैरो, अंकज्योतिष और 15+ सेवाएं",
            description: "BhriguGPT से चैट करें — आपका AI ज्योतिषी। मुफ्त कुंडली, टैरो, अंकज्योतिष, राशिफल, पंचांग, हस्तरेखा और 15+ आध्यात्मिक सेवाएं हिंदी और अंग्रेजी में।",
            keywords: "AI ज्योतिषी, वैदिक ज्योतिष, कुंडली, टैरो रीडिंग, अंकज्योतिष, हस्तरेखा, राशिफल, पंचांग, जन्म कुंडली, मुखाकृति विज्ञान, स्वप्न व्याख्या, कुंडली मिलान, KP ज्योतिष, लाल किताब, चीनी ज्योतिष, पाश्चात्य ज्योतिष, पूर्व जन्म, ज्योतिष, मुफ्त कुंडली, AI ज्योतिष चैट",
            ogTitle: "BhriguGPT - आपका व्यक्तिगत AI ज्योतिषी | 15+ आध्यात्मिक सेवाएं",
            ogDescription: "वैदिक कुंडली से लेकर टैरो, अंकज्योतिष, हस्तरेखा, पाश्चात्य और चीनी ज्योतिष तक — BhriguGPT जीवन के बड़े सवालों का AI-संचालित मार्गदर्शक है।",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/"
        }
    },

    // Free Kundli Page
    freeKundli: {
        English: {
            title: "Free Kundli Online - Instant Birth Chart & Predictions | BhriguGPT",
            description: "Generate your free Kundli (birth chart) instantly with accurate Vedic astrology calculations. Get detailed planetary positions, doshas, and life predictions based on your birth details.",
            keywords: "free kundli, birth chart, janam kundli, vedic birth chart, online kundli, kundli matching, horoscope chart, astrology chart, janam patri",
            ogTitle: "Free Kundli - Accurate Vedic Birth Chart by BhriguGPT",
            ogDescription: "Create your detailed Kundli with planetary positions, doshas, and predictions. 100% accurate Vedic astrology calculations.",
            ogImage: DEFAULT_OG_IMAGE
        },
        Hindi: {
            title: "मुफ्त कुंडली ऑनलाइन - तुरंत जन्म कुंडली और भविष्यवाणियां | BhriguGPT",
            description: "सटीक वैदिक ज्योतिष गणना के साथ अपनी मुफ्त कुंडली (जन्म कुंडली) तुरंत बनाएं। जन्म विवरण के आधार पर विस्तृत ग्रह स्थिति, दोष और जीवन की भविष्यवाणियां प्राप्त करें।",
            keywords: "मुफ्त कुंडली, जन्म कुंडली, जन्म पत्री, वैदिक कुंडली, ऑनलाइन कुंडली, कुंडली मिलान, राशिफल चार्ट, ज्योतिष चार्ट",
            ogTitle: "मुफ्त कुंडली - BhriguGPT द्वारा सटीक वैदिक जन्म कुंडली",
            ogDescription: "ग्रह स्थिति, दोष और भविष्यवाणियों के साथ अपनी विस्तृत कुंडली बनाएं। 100% सटीक वैदिक ज्योतिष गणना।",
            ogImage: DEFAULT_OG_IMAGE
        }
    },

    // Horoscope Page
    horoscope: {
        English: {
            title: "Free Daily Horoscope & Zodiac Predictions | BhriguGPT",
            description: "Get accurate daily, weekly, and monthly horoscope predictions for all zodiac signs. Know what stars have in store for love, career, health, and money with Vedic astrology.",
            keywords: "daily horoscope, zodiac signs, rashi bhavishya, astrology predictions, weekly horoscope, monthly horoscope, sun sign, moon sign",
            ogTitle: "Daily Horoscope - Accurate Zodiac Predictions by BhriguGPT",
            ogDescription: "Free daily horoscope for all zodiac signs. Get insights on love, career, health, and wealth based on Vedic astrology.",
            ogImage: DEFAULT_OG_IMAGE
        },
        Hindi: {
            title: "मुफ्त दैनिक राशिफल और राशि भविष्यवाणी | BhriguGPT",
            description: "सभी राशियों के लिए सटीक दैनिक, साप्ताहिक और मासिक राशिफल भविष्यवाणियां प्राप्त करें। वैदिक ज्योतिष के साथ प्रेम, करियर, स्वास्थ्य और धन के बारे में जानें।",
            keywords: "दैनिक राशिफल, राशि चक्र, राशि भविष्य, ज्योतिष भविष्यवाणी, साप्ताहिक राशिफल, मासिक राशिफल, सूर्य राशि, चंद्र राशि",
            ogTitle: "दैनिक राशिफल - BhriguGPT द्वारा सटीक राशि भविष्यवाणी",
            ogDescription: "सभी राशियों के लिए मुफ्त दैनिक राशिफल। वैदिक ज्योतिष पर आधारित प्रेम, करियर, स्वास्थ्य और धन की जानकारी।",
            ogImage: DEFAULT_OG_IMAGE
        }
    },

    // Panchang Page
    panchang: {
        English: {
            title: "Today's Panchang - Hindu Calendar & Auspicious Timings | BhriguGPT",
            description: "Check today's Vedic Panchang with Tithi, Nakshatra, Yoga, and Karana. Find auspicious muhurat timings, festivals, sunrise-sunset times for any location.",
            keywords: "panchang, hindu calendar, tithi, nakshatra, muhurat, auspicious timing, vedic calendar, panchangam, hindu panchang today",
            ogTitle: "Panchang Today - Vedic Calendar & Muhurat Timings",
            ogDescription: "Get complete daily Panchang with Tithi, Nakshatra, planetary positions, and auspicious timings for your location.",
            ogImage: DEFAULT_OG_IMAGE
        },
        Hindi: {
            title: "आज का पंचांग - हिंदू कैलेंडर और शुभ मुहूर्त | BhriguGPT",
            description: "तिथि, नक्षत्र, योग और करण के साथ आज का वैदिक पंचांग देखें। किसी भी स्थान के लिए शुभ मुहूर्त समय, त्योहार, सूर्योदय-सूर्यास्त समय प्राप्त करें।",
            keywords: "पंचांग, हिंदू कैलेंडर, तिथि, नक्षत्र, मुहूर्त, शुभ समय, वैदिक कैलेंडर, पंचांगम, आज का पंचांग",
            ogTitle: "आज का पंचांग - वैदिक कैलेंडर और मुहूर्त समय",
            ogDescription: "तिथि, नक्षत्र, ग्रह स्थिति और आपके स्थान के लिए शुभ समय के साथ संपूर्ण दैनिक पंचांग प्राप्त करें।",
            ogImage: DEFAULT_OG_IMAGE
        }
    },

    // Contact Page
    contact: {
        English: {
            title: "Contact Us - Get in Touch with BhriguGPT Support",
            description: "Have questions about Vedic astrology or need help with our services? Contact BhriguGPT support team. We're here to assist you with Kundli, Horoscope, and Panchang queries.",
            keywords: "contact astrologer, astrology support, kundli help, horoscope contact, vedic astrology consultation",
            ogTitle: "Contact BhriguGPT - Astrology Support",
            ogDescription: "Get in touch with BhriguGPT for astrology consultation and support.",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/contact"
        },
        Hindi: {
            title: "संपर्क करें - BhriguGPT सपोर्ट से संपर्क करें",
            description: "वैदिक ज्योतिष के बारे में प्रश्न हैं या हमारी सेवाओं में सहायता चाहिए? BhriguGPT सपोर्ट टीम से संपर्क करें। हम आपकी कुंडली, राशिफल और पंचांग संबंधी प्रश्नों में सहायता के लिए यहां हैं।",
            keywords: "ज्योतिषी से संपर्क, ज्योतिष सपोर्ट, कुंडली सहायता, राशिफल संपर्क, वैदिक ज्योतिष परामर्श",
            ogTitle: "BhriguGPT से संपर्क करें - ज्योतिष सपोर्ट",
            ogDescription: "ज्योतिष परामर्श और सपोर्ट के लिए BhriguGPT से संपर्क करें।",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/contact"
        }
    },

    // Privacy Policy Page
    privacy: {
        English: {
            title: "Privacy Policy - How We Protect Your Data | BhriguGPT",
            description: "Read BhriguGPT's privacy policy to understand how we collect, use, and protect your personal information and birth details. Your privacy is our priority.",
            keywords: "privacy policy, data protection, user privacy, astrology privacy, data security",
            ogTitle: "BhriguGPT Privacy Policy",
            ogDescription: "Learn how BhriguGPT protects your personal information and birth details.",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/privacy"
        },
        Hindi: {
            title: "गोपनीयता नीति - हम आपके डेटा की सुरक्षा कैसे करते हैं | BhriguGPT",
            description: "BhriguGPT की गोपनीयता नीति पढ़ें और समझें कि हम आपकी व्यक्तिगत जानकारी और जन्म विवरण को कैसे एकत्र, उपयोग और सुरक्षित करते हैं। आपकी गोपनीयता हमारी प्राथमिकता है।",
            keywords: "गोपनीयता नीति, डेटा सुरक्षा, उपयोगकर्ता गोपनीयता, ज्योतिष गोपनीयता, डेटा सुरक्षा",
            ogTitle: "BhriguGPT गोपनीयता नीति",
            ogDescription: "जानें कि BhriguGPT आपकी व्यक्तिगत जानकारी और जन्म विवरण की सुरक्षा कैसे करता है।",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/privacy"
        }
    },

    // Terms of Service Page
    terms: {
        English: {
            title: "Terms of Service - Usage Guidelines | BhriguGPT",
            description: "Read BhriguGPT's terms of service to understand the rules and guidelines for using our Vedic astrology platform, including Kundli, Horoscope, and Panchang services.",
            keywords: "terms of service, user agreement, astrology terms, service guidelines, usage policy",
            ogTitle: "BhriguGPT Terms of Service",
            ogDescription: "Understand the terms and conditions for using BhriguGPT's astrology services.",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/terms"
        },
        Hindi: {
            title: "सेवा की शर्तें - उपयोग दिशानिर्देश | BhriguGPT",
            description: "BhriguGPT की सेवा की शर्तें पढ़ें और हमारे वैदिक ज्योतिष प्लेटफ़ॉर्म का उपयोग करने के नियम और दिशानिर्देश समझें, जिसमें कुंडली, राशिफल और पंचांग सेवाएं शामिल हैं।",
            keywords: "सेवा की शर्तें, उपयोगकर्ता समझौता, ज्योतिष शर्तें, सेवा दिशानिर्देश, उपयोग नीति",
            ogTitle: "BhriguGPT सेवा की शर्तें",
            ogDescription: "BhriguGPT की ज्योतिष सेवाओं का उपयोग करने के लिए नियम और शर्तें समझें।",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/terms"
        }
    },

    // Refund Policy Page
    refunds: {
        English: {
            title: "Refund Policy - Money Back Guarantee | BhriguGPT",
            description: "Learn about BhriguGPT's refund and cancellation policy for astrology consultations and premium services. We value your satisfaction and trust.",
            keywords: "refund policy, money back, cancellation policy, astrology refund, service refund",
            ogTitle: "BhriguGPT Refund Policy",
            ogDescription: "Understand BhriguGPT's refund and cancellation terms for premium astrology services.",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/refunds"
        },
        Hindi: {
            title: "रिफंड नीति - पैसे वापसी की गारंटी | BhriguGPT",
            description: "ज्योतिष परामर्श और प्रीमियम सेवाओं के लिए BhriguGPT की रिफंड और रद्दीकरण नीति के बारे में जानें। हम आपकी संतुष्टि और विश्वास को महत्व देते हैं।",
            keywords: "रिफंड नीति, पैसे वापसी, रद्दीकरण नीति, ज्योतिष रिफंड, सेवा वापसी",
            ogTitle: "BhriguGPT रिफंड नीति",
            ogDescription: "प्रीमियम ज्योतिष सेवाओं के लिए BhriguGPT की रिफंड और रद्दीकरण शर्तें समझें।",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/refunds"
        }
    },

    // Login Page
    login: {
        English: {
            title: "Login to BhriguGPT - Access Your Astrology Dashboard",
            description: "Sign in to your BhriguGPT account to access personalized horoscopes, saved Kundlis, AI astrology chat, and premium Vedic astrology services.",
            keywords: "astrology login, bhrigu gpt login, horoscope account, kundli login, astrology account",
            ogTitle: "Login to BhriguGPT",
            ogDescription: "Access your personalized astrology dashboard with saved Kundlis and AI consultations.",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/login"
        },
        Hindi: {
            title: "BhriguGPT में लॉगिन करें - अपने ज्योतिष डैशबोर्ड तक पहुंचें",
            description: "व्यक्तिगत राशिफल, सहेजी गई कुंडलियां, AI ज्योतिष चैट और प्रीमियम वैदिक ज्योतिष सेवाओं तक पहुंचने के लिए अपने BhriguGPT खाते में साइन इन करें।",
            keywords: "ज्योतिष लॉगिन, भृगु GPT लॉगिन, राशिफल खाता, कुंडली लॉगिन, ज्योतिष खाता",
            ogTitle: "BhriguGPT में लॉगिन करें",
            ogDescription: "सहेजी गई कुंडलियों और AI परामर्श के साथ अपने व्यक्तिगत ज्योतिष डैशबोर्ड तक पहुंचें।",
            ogImage: DEFAULT_OG_IMAGE,
            canonicalUrl: "/login"
        }
    }
};

// Dynamic meta tags based on URL parameters
export const getDynamicMetaTags = (
    page: string,
    language: string = 'English',
    params?: Record<string, string>
): MetaTagConfig => {
    const baseMeta = SEO_META_TAGS[page]?.[language] || SEO_META_TAGS.landing[language];

    // Dynamic title and description for specific pages
    if (page === 'horoscope' && params) {
        const { sign, period, date } = params;
        if (sign && language === 'English') {
            const periodText = period === 'today'
                ? 'Today'
                : period === 'weekly'
                    ? 'Weekly'
                    : period === 'monthly'
                        ? 'Monthly'
                        : 'Yearly';
            const dateLabel = period === 'today' && date ? ` for ${date}` : '';
            return {
                ...baseMeta,
                title: `${sign} Horoscope ${periodText}${dateLabel} | BhriguGPT`,
                description: `Get accurate ${periodText.toLowerCase()} horoscope${dateLabel} for ${sign}. Know what stars predict for love, career, health, and finance with Vedic astrology.`
            };
        } else if (sign && language === 'Hindi') {
            const periodText = period === 'today'
                ? 'आज का'
                : period === 'weekly'
                    ? 'साप्ताहिक'
                    : period === 'monthly'
                        ? 'मासिक'
                        : 'वार्षिक';
            const dateLabel = period === 'today' && date ? ` ${date} के लिए` : '';
            return {
                ...baseMeta,
                title: `${sign} राशिफल ${periodText}${dateLabel} | BhriguGPT`,
                description: `${sign} के लिए सटीक ${periodText} राशिफल${dateLabel} प्राप्त करें। वैदिक ज्योतिष के साथ प्रेम, करियर, स्वास्थ्य और वित्त की भविष्यवाणी जानें।`
            };
        }
    }

    if (page === 'panchang' && params) {
        const { date, locationName } = params;
        if (date && locationName && language === 'English') {
            return {
                ...baseMeta,
                title: `Panchang for ${locationName} on ${date} - Hindu Calendar | BhriguGPT`,
                description: `Complete Vedic Panchang for ${locationName} on ${date}. Get Tithi, Nakshatra, Yoga, auspicious timings, and planetary positions.`
            };
        } else if (date && locationName && language === 'Hindi') {
            return {
                ...baseMeta,
                title: `${date} को ${locationName} के लिए पंचांग - हिंदू कैलेंडर | BhriguGPT`,
                description: `${date} को ${locationName} के लिए संपूर्ण वैदिक पंचांग। तिथि, नक्षत्र, योग, शुभ समय और ग्रह स्थिति प्राप्त करें।`
            };
        }
    }

    return baseMeta;
};
